import { Button } from '../components/ui/primitives';

/**
 * Sign-in. Deliberately plain: one action, no marketing, no illustration.
 * The button is a link, not a fetch — the OIDC flow is a full-page redirect.
 */
export function SignIn() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-paper px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <h1 className="text-xl font-semibold tracking-tight text-ink-900">Zoye</h1>
          <p className="mt-1 text-sm text-ink-500">AI customer support console · Impact Brands</p>
        </div>

        <div className="rounded-lg bg-surface p-6 shadow-hairline shadow-raised">
          <h2 className="text-sm font-semibold text-ink-900">Sign in</h2>
          <p className="mt-1 text-xs text-ink-500">
            Use your @theimpactbrands.com Google Workspace account.
          </p>
          <Button
            variant="primary"
            size="lg"
            className="mt-5 w-full"
            onClick={() => {
              window.location.href = '/auth/login';
            }}
          >
            Continue with Google
          </Button>
        </div>

        <p className="mt-4 text-xs text-ink-400">
          New accounts start with no brand access. An administrator grants it after you sign in.
        </p>
      </div>
    </main>
  );
}
